import type FlagList from '@/bps/types/FlagList';

class ProductBoxWideSettings {
  flags: {
    whitelistImage: FlagList
    whitelistTag: string[]
    whitelistConversion: string[]
  };
  rating: {
    type: string
  }
  readMoreLink: boolean
  personalisationTop: boolean
}

const productBoxWideSettings = new ProductBoxWideSettings();

productBoxWideSettings.flags = {
  whitelistImage: ['free', 'new', 'stoerer', 'award', 'nachhaltigkeit', 'bio', 'vegan', 'boxSetUrl'],
  whitelistTag: [],
  whitelistConversion: ['savings'],
};

productBoxWideSettings.rating = {
  type: 'disabled'
};

productBoxWideSettings.readMoreLink = true;
productBoxWideSettings.personalisationTop = false;

export {productBoxWideSettings, ProductBoxWideSettings};
